import axios from "axios";
import authHeader from '../../../authheader'

const LSIREINSTATEMENTURL = process.env.REACT_APP_APIURL + "/api/IndividualEiReinstatement";

const getViolation = (reinstatementId) => {
    return axios.get(`${LSIREINSTATEMENTURL}/violation`, { headers: authHeader(), params: { reinstatementId } });
}
const postViolation = (data) => {
    return axios.post(`${LSIREINSTATEMENTURL}/violation`, data, { headers: authHeader() });
}
export default {
    getViolation,
    postViolation
}